import icon from '../../assets/img/icons/congrats.svg'
const ServiceCongrats = () => {

    return (
        <div class="modal fade" id="congratsModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <a type="button" class="btn-skip" data-bs-dismiss="modal">Skip</a>
                        <div class="px-2 pt-3 text-center congratsModal">
                            <img class="mb-4" src={icon} alt="#" />
                            <h5 class="mb-2">CONGRATULATIONS!</h5>
                            <p>Nice Work, Shafina!</p>
                            <span>Your profile is ready</span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button data-bs-dismiss="modal" class="button px-0">View Profile</button>
                        <button data-bs-dismiss="modal" class="button button-primary">Setup Payment Mode</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ServiceCongrats